import * as types from "../../actions/types";



const initialState = null


export default function about (state = initialState, action) {
  switch (action.type) {
      
    case types.SET_SETTINGS_ABOUT_DATA:
      return action.payload

    default:
      return state;
  }
}